import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { Prevision, RequestResponseGetAllPrevision, RequestResponseActualizar } from 'src/app/shared/models/prevision.interface';

@Injectable({
  providedIn: 'root'
})
export class PrevisionService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //GetAll_previsiones
  traerPrevisiones(): Observable<RequestResponseGetAllPrevision> {
    return this.http
    .get<RequestResponseGetAllPrevision >(`${environment.API}/rrhh/prevision/`)
    .pipe(
      map((res:RequestResponseGetAllPrevision) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Create_prevision
  crearPrevision(prevision:Prevision): Observable<RequestResponse> {      
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/prevision/crear`,prevision)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_prevision
  actualizarPrevision(prevision:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/prevision/actualizar/${prevision.id}`,prevision)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_prevision
  obtenerPrevision(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/prevision/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Eliminar_prevision
  eliminarPrevision(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/prevision/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }


  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
}
